import cuid from "cuid";

export const heatmap = {
  methods: {
    createSquaresFromHeatPoints(heatPoints) {
      const data = heatPoints;
      const squares = [];

      for (let row1 = 0, row2 = 1; row2 < data.length; row1++, row2++) {
        for (let col1 = 0, col2 = 1; col2 < data.length; col1++, col2++) {
          const square = {
            points: [
              data[row1][col1],
              data[row1][col2],
              data[row2][col1],
              data[row2][col2]
            ],
            id: cuid()
          };
          squares.push(square);
        }
      }

      return squares;
    }
  }
};
